









    import Vue from "vue";

    export default Vue.extend({
        props: {
            show: {
                required: true,
                type: Boolean
            }
        }
    });
